import React from 'react';
import { LiveEvent } from '../types';
import { formatDistanceToNow } from 'date-fns';
import { Radio } from 'lucide-react';

interface Props {
  events:    LiveEvent[];
  connected: boolean;
}

const TYPE_LABEL: Record<string, string> = {
  signal:     'Signal',
  enrichment: 'Identified',
  popup:      'Popup shown',
  consent:    'Consent',
  outreach:   'Outreach',
};

export function LiveFeed({ events, connected }: Props) {
  return (
    <div className="page">
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 20 }}>
        <Radio size={18} color={connected ? 'var(--green)' : 'var(--red)'} />
        <div>
          <div style={{ fontWeight: 700, fontSize: 16 }}>Live Feed</div>
          <div style={{ fontSize: 12, color: 'var(--text3)', fontFamily: 'var(--mono)' }}>
            {connected ? 'Connected — real-time events streaming' : 'Disconnected from API'}
          </div>
        </div>
        <span className={`badge ${connected ? 'badge-green' : 'badge-red'}`} style={{ marginLeft: 'auto' }}>
          {connected ? 'Live' : 'Offline'}
        </span>
      </div>

      {events.length === 0 ? (
        <div className="empty">
          <Radio size={32} style={{ opacity: 0.3 }} />
          <div className="empty-title">Waiting for events...</div>
          <div style={{ fontSize: 12, color: 'var(--text3)' }}>
            {connected
              ? 'Events will appear here as visitors interact with your website'
              : 'Start the API server to see live events'}
          </div>
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
          {events.map(ev => (
            <div key={ev.id} className="feed-item" style={{ gap: 14 }}>
              {/* Type badge */}
              <span className="badge" style={{
                background: ev.color + '22',
                color: ev.color,
                minWidth: 80,
                justifyContent: 'center',
                flexShrink: 0,
              }}>
                {TYPE_LABEL[ev.type] ?? ev.type}
              </span>

              {/* Dot */}
              <div className="feed-dot" style={{ background: ev.color, marginTop: 6 }} />

              {/* Content */}
              <div style={{ flex: 1, minWidth: 0 }}>
                <div className="feed-label">{ev.label}</div>
                {ev.sublabel && <div className="feed-sub">{ev.sublabel}</div>}
                <div style={{ fontSize: 10, color: 'var(--text3)', fontFamily: 'var(--mono)', marginTop: 2 }}>
                  session: {ev.sessionId.slice(0, 12)}...
                </div>
              </div>

              {/* Time */}
              <div className="feed-time" style={{ flexShrink: 0 }}>
                {formatDistanceToNow(new Date(ev.ts), { addSuffix: true })}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
